import { useCallback, useState } from 'react';

import CasTabs, { TabItem } from './_internal/CasTabs';
import CasTabsPanel from './_internal/CasTabsPanel';

// ----------------------------------------------------------------------

interface ICasTabsView {
  className?: string;
  tabList: TabItem[];
  onTabChange?: (tab: string) => void;
  defaultActiveTab?: string | null;
  onActiveTabChange?: (activeTab: string) => void;
  centered?: boolean;
}

export default function CasTabsView({
  className,
  tabList,
  onTabChange,
  defaultActiveTab,
  onActiveTabChange,
  centered = false,
}: ICasTabsView) {
  const [activeTab, setActiveTab] = useState(defaultActiveTab ?? tabList[0].label);

  const handleTabChange = useCallback((_: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
    if (onTabChange) onTabChange(newValue);
    if (onActiveTabChange) onActiveTabChange(newValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <CasTabs 
        value={activeTab} 
        handleTabchange={handleTabChange} 
        tabList={tabList} 
        className={className} 
        centered={centered} 
      />
      {tabList.map(({ label, children }) => (
        <CasTabsPanel value={activeTab} index={label} key={label}>
          {children}
        </CasTabsPanel>
      ))}
    </>
  );
}
